"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import TicketPaymentList from "./TicketPaymentList"
import TicketPaymentModal from "./TicketPaymentModal"
import TicketVerificationModal from "./TicketVerificationModal"
import type { TicketPayment } from "./types"

const TicketPaymentContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [verificationModalOpen, setVerificationModalOpen] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState<TicketPayment | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedPayment(null)
    setModalOpen(true)
  }

  const handleOpenDetails = (payment: TicketPayment) => {
    setSelectedPayment(payment)
    setModalOpen(true)
  }

  const handleOpenVerification = () => {
    setVerificationModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setVerificationModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Ticket Payments" parent="Ticketing System" />
      <Container fluid>
        <Row>
          <Col md="12">
            <TicketPaymentList
              onAdd={handleOpenAdd}
              onViewDetails={handleOpenDetails}
              onVerifyTicket={handleOpenVerification}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        <TicketPaymentModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          paymentData={selectedPayment}
        />

        <TicketVerificationModal
          isOpen={verificationModalOpen}
          toggle={() => setVerificationModalOpen(false)}
          onSuccess={handleSuccess}
        />
      </Container>
    </>
  )
}

export default TicketPaymentContainer
